<template>
  <v-container
    fluid
    tag="section"
  >
    <v-row>
      <v-col>
        <item-list
          :dialog-visible="dialogVisible"
          :item-url="conditionItems.url"
          @close="dialogVisible = false"
          @getItem="getItem"
        />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col
        cols="12"
        md="10"
        sm="10"
      >
        <base-material-card>
          <template v-slot:heading>
            <div class="subtitle-1 font-weight-light">
              Условие для Правила:
            </div>
            <div class="display-1 font-weight-light">
              {{ Rule ? Rule.name : "" }}
            </div>
            <div class="subtitle-1 font-weight-light">
              {{ Rule ? Rule.description : "" }}
            </div>
          </template>
          <v-card-title />
          <v-card-text>
            <v-col>
              <v-row>
                <v-col
                  :md="conditionItems.widthCol"
                  cols="12"
                  sm="12"
                >
                  <v-select
                    v-model="Condition.parameter"
                    :items="conditionParameterList"
                    label="Параметр"
                    @change="getParameter"
                  />
                </v-col>
                <v-col
                  v-if="conditionItems.comparisonOpShow"
                  cols="12"
                  md="4"
                  sm="12"
                >
                  <v-select
                    v-model="Condition.comparisonOp"
                    :items="conditionItems.conditionComparisonOpList"
                    label="Операция сравнения"
                  />
                </v-col>
                <v-col
                  v-if="conditionItems.comparisonOpShow"
                  cols="12"
                  md="4"
                  sm="12"
                >
                  <v-text-field
                    v-model="Condition.value"
                    label="Значение"
                    placeholder="Значение параметра"
                  >
                    <template
                      v-if="conditionItems.postButtonShow"
                      v-slot:append-outer
                    >
                      <v-menu
                        offset-y
                        style="top: -12px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            @click="openDialog"
                            v-on="on"
                          >
                            mdi-account-search-outline
                          </v-icon>
                        </template>
                      </v-menu>
                    </template>
                  </v-text-field>
                </v-col>

                <v-col
                  v-if="!conditionItems.comparisonOpShow"
                  cols="12"
                  md="5"
                  sm="12"
                >
                  <v-checkbox
                    v-model="Condition.value"
                    false-value="0"
                    label="Значение параметра"
                    true-value="1"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-card-text>
          <v-divider />
          <v-card-actions justify="center">
            <v-row
              align-content="space-between"
              justify="space-around"
            >
              <v-btn
                color="primary"
                outlined
                @click="back"
              >
                Назад
              </v-btn>
              <v-btn
                :disabled="newNameInvalid"
                color="primary"
                @click="conditionId > 0 ? save() : create()"
              >
                {{
                  conditionId > 0 ? "Сохранить" : "Создать"
                }}
              </v-btn>
            </v-row>
          </v-card-actions>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// import { getConditionParameterList } from "../../shared/modules/utilities"
import WebApi from "../../shared/modules/web_api"
import ConditionItem from "../../shared/classes/condition-item"
import ItemList from "../../shared/components/item-list/ItemList"
import Condition_class from "@/views/loyalty/shared/classes/condition_class"
import RuleModel from "@/views/loyalty/models/rule.model"

export default {
    name: "ConditionEdit",
    components: { ItemList },
    data: () => ({
        Condition: {},
        headers: [
            {
                text: "ID",
                value: "itemId"
            },
            {
                text: "Наименование",
                value: "itemName"
            },
            {
                text: "Выбрать",
                value: "actions"
            }
        ],
        Rule: {},
        attributes: [],
        conditionId: 0,
        conditionItem: null,
        conditionItems: {},
        conditionParameterList: [],
        dialogVisible: false,
        webApi: null
    }),
    computed: {
        // conditionParameterList () {
        //   return this.getConditionParameterList()
        // },
        // conditionComparisonOpList() {
        //   return this.conditionComparisonOpList;
        // },
        // conditionComparisonBinaryOpList() {
        //   return getConditionComparisonBinaryOpList();
        // },
        // comparisonOp() {
        //   return this.comparisonOp;
        // },
        newNameInvalid () {
            return !this.Condition.value || this.Rule.ruleId <= 0
        }
    },
    async beforeMount () {
        console.log('route.params', this.$route.params)
        const ruleId = +this.$route.params.rule
        this.conditionId = +this.$route.params.condition
        this.webApi = new WebApi(this.$store)
            .createSuccess("Условие создано!")
            .createError("Произошла ошибка при создании Условия!")
            .editSuccess("Условие сохранено!")
            .editError("Произошла ошибка при сохранении Условия!")
            .readError("Произошла ошибка при чтении данных")
        const response = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}rule/${ruleId}`)
        this.Rule = Reflect.construct(RuleModel, [response])
        if (this.conditionId === 0) {
            this.Condition = Reflect.construct(Condition_class, []).item
            this.Condition.ruleId = this.Rule.ruleId
            this.conditionItem = new ConditionItem()
                .getFeature(this.Condition.parameter)
                .conditionComparisonOpList()
            Object.assign(this.conditionItems, this.conditionItem.getConditionItems())
            console.log('conditionItems', this.conditionItems)
            this.attributes = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/attributes/`)
        } else {
            this.Condition = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/condition/${this.conditionId}`)
            this.attributes = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/attributes/`)
            const attribute = this.attributes.find(f => f.mnemonic === this.Condition.parameter)
            console.log('attribute', attribute)
            console.log('this.Condition', this.Condition)
            console.log(typeof this.Condition.value)
            this.conditionItem = new ConditionItem()
                .getFeature(this.Condition.parameter, attribute)
                .conditionComparisonOpList()
            Object.assign(this.conditionItems, this.conditionItem.getConditionItems())
            console.log('conditionItems', this.conditionItems)
        }
        this.conditionParameterList = await this.webApi.get(`${process.env.VUE_APP_LOYALTY_URL}api/condition_param/${this.$store.state.user.current_client}`)
        console.log('conditionParameterList', this.conditionParameterList)
    },
    methods: {
        compareConditions (parameter, ...items) {
            var result = false
            for (const item of items) {
                result |= parameter === item
            }
            return result
        },
        async create () {
            console.log("create")
            const data = Object.assign({}, this.Condition)
            delete data.conditionId
            this.Condition = await this.webApi.post(`${process.env.VUE_APP_LOYALTY_URL}condition/`, data)
            this.Condition.conditionId = data.conditionId
            this.back()
        },
        back () {
            this.$router.back()
        },
        getItem (item) {
            console.log('getItem', item)
            this.Condition.value = item.itemId
        },
        getParameter () {
            console.log('getParameter', this.Condition.parameter)
            const attribute = this.attributes.find(f => f.mnemonic === this.Condition.parameter)
            console.log('attribute', attribute)
            Object.assign(
                this.conditionItems,
                this.conditionItem
                    .getFeature(this.Condition.parameter, attribute)
                    .conditionComparisonOpList()
                    .getUrl(this.Condition.parameter)
                    .getConditionItems()
            )
            if (!this.conditionItems.comparisonOpShow) {
                this.Condition.comparisonOp = "=="
            }
            console.log('conditionItems', this.conditionItems)
        },
        openDialog () {
            console.log("dialog is open")
            this.dialogVisible = true
        },
        save () {
            console.log("saving...")
            this.webApi.patch(
                `${process.env.VUE_APP_LOYALTY_URL}condition/` +
                this.Condition.conditionId,
                this.Condition
            )
            this.back()
        }
    }
}
</script>

<style scoped></style>
